import { createFileRoute } from '@tanstack/react-router'
import {
  type ReportStatus,
  type ReportTargetType,
  type ReportReason,
} from '@/lib/api/domains/moderation.types'
import { Moderation } from '@/features/moderation'

export const Route = createFileRoute('/_authenticated/moderation/')({
  validateSearch: (
    search: Record<string, unknown>
  ): {
    page?: number
    pageSize?: number
    status?: ReportStatus
    targetType?: ReportTargetType
    reason?: ReportReason
  } => {
    return {
      page: Number(search?.page) || 1,
      pageSize: Number(search?.pageSize) || 20,
      status: search?.status as ReportStatus | undefined,
      targetType: search?.targetType as ReportTargetType | undefined,
      reason: search?.reason as ReportReason | undefined,
    }
  },
  component: Moderation,
})
